import React, { useState, useEffect } from "react";
import { Edit } from "react-feather";
import { Button, Label } from "reactstrap";
import BehalfModal from "./behalfModal";
import useFetcher from "../../hooks/useFetcher";
import { fetchPiAsignable } from "../../services/ticketingServices";

const CreateTicketInBehalf = ({ createInBehalf, formik, setisOnBehalf, isOnBehalf }) => {
  const [piAsignable] = useFetcher(fetchPiAsignable, undefined, "allfetchPiAsignable");
  const [createInBehalfModal, setCreateInBehalfModal] = useState(false);
  const [createInBehalfName, setCreateInBehalfName] = useState("");
  const [onBehalfErrors, setonBehalfErrors] = useState(false);

  useEffect(() => {
    if (formik.values.nombre && formik.values.apellido) {
      setCreateInBehalfName(`${formik.values.nombre} ${formik.values.apellido}`);
    } else if (formik.values.piAsignado) {
      setCreateInBehalfName(
        `${
          piAsignable.find((pi) => {
            return pi.itemId === formik.values.piAsignado;
          }).nombreApellido
        }`
      );
    } else {
      setCreateInBehalfName(createInBehalf);
    }
    if (formik.errors) {
      if (
        (formik.errors.categoria && formik.touched.categoria) ||
        (formik.errors.nombre && formik.touched.nombre) ||
        (formik.errors.apellido && formik.touched.apellido) ||
        (formik.errors.dniCreador && formik.touched.dniCreador)
      ) {
        setonBehalfErrors(true);
      } else {
        setonBehalfErrors(false);
      }
    }
    if (formik.values.dniCreador === "") {
      formik.setFieldValue("dniCreador", undefined);
    }
    if (formik.values.telefonoCreador === "") {
      formik.setFieldValue("telefonoCreador", undefined);
    }
    if (formik.values.nombre === "") {
      formik.setFieldValue("nombre", undefined);
    }
    if (formik.values.apellido === "") {
      formik.setFieldValue("apellido", undefined);
    }
    if (formik.values.email === "") {
      formik.setFieldValue("email", undefined);
    }
  }, [formik]);

  return (
    <>
      {createInBehalfModal ? (
        <BehalfModal toggle={() => setCreateInBehalfModal(!createInBehalfModal)} formik={formik} setisOnBehalf={setisOnBehalf} isOnBehalf={isOnBehalf} />
      ) : null}
      <div className="mb-3">
        <Label htmlFor="createdInBehalf" className="col-form-label pt-0 w-100">
          Creado para
        </Label>
        <div className="d-flex justify-content-between w-100">
          <Label className="col-form-label text-muted text-uppercase">{createInBehalfName}</Label>
          <Button color="link" size="xs" className="pt-1" onClick={() => setCreateInBehalfModal(!createInBehalfModal)}>
            <Edit size="24" />
          </Button>
        </div>
        {onBehalfErrors && <div className="input-feedback">Tiene datos por completar.</div>}
      </div>
    </>
  );
};

export default CreateTicketInBehalf;
